import {point3d, TextHorizontalAlignment, TextVerticalAlignment} from "@tarikjabiri/dxf";
import {calculateCenter, calculateDistance, calculateMidpoint, inch2feet} from "./DxfCalculations";

// Adds a label to the center of a polygon. If it's an obstruction, styling and label text are adjusted accordingly.
export function addNameLabel(polygon3D, Block, label, isObs) {
    const center = calculateCenter(polygon3D); // Find geometric center of polygon
    const fontSize = isObs ? 4 : 12; // Smaller font for obstructions
    const fontColor = isObs ? 10 : 40; // Use different color for obstructions
    label = isObs ? `P${label}` : label; // Prefix label for obstructions
    const alignment = isObs ? {horizontal: TextHorizontalAlignment.Center, vertical: TextVerticalAlignment.Middle} :
        {horizontal: TextHorizontalAlignment.Center, vertical: TextVerticalAlignment.Middle};
    addLabel(Block, label, fontSize, fontColor, center, alignment); // Add the text label to the drawing
}

// Adds distance labels between each pair of consecutive points in a path/segment
export function addMeasurementLable(adjustedPoints, inchesPoints, Block) {
    for (let i = 0; i < adjustedPoints.length - 1; i++) {
        const segmentDistance = inch2feet(calculateDistance(adjustedPoints[i], adjustedPoints[i + 1])); // Convert distance to feet
        const midpoint = calculateMidpoint(inchesPoints[i].point, inchesPoints[i + 1].point); // Find midpoint of the segment
        const fontSize = 10;
        const fontColor = 112;
        const alignment = {horizontal: TextHorizontalAlignment.Center, vertical: TextVerticalAlignment.Bottom};
        addLabel(Block, segmentDistance, fontSize, fontColor, midpoint, alignment); // Add text to midpoint
    }
}

// Adds labels to individual points, skipping the last one (commonly used for POI indexing)
export function addPointLabels(points, Block) {
    points.forEach((point, index) => {
        const midpoint = point3d(points[index].point.x + 0.8, points[index].point.y + 0.8, 0); // Offset text slightly from point
        const fontSize = 9;
        const fontColor = 10;
        const alignment = {horizontal: TextHorizontalAlignment.Center, vertical: TextVerticalAlignment.Bottom};
        if (index !== points.length - 1) { // Skip final point if it's a duplicate (e.g., closed polygon)
            addLabel(Block, index, fontSize, fontColor, midpoint, alignment); // Label the point with its index
        }
    });
}

// Adds detail labels for segment properties (key-value pairs) plus a segment title
export function SegmentDetailLabels(drawing, startX, startY, data, label) {
    let spaceY = startY;
    Object.entries(data).forEach(([key, value]) => {
        if (value != null) {
            const position = point3d(startX, spaceY);
            const fontSize = 12;
            const fontColor = 52;
            const alignment = {horizontal: TextHorizontalAlignment.Left, vertical: TextVerticalAlignment.Middle};
            addLabel(drawing, `${key}: ${value.toString()}`, fontSize, fontColor, position, alignment); // Add line of detail
            spaceY += 19.5; // Move down for next label
        }
    });
    // Add section title label
    const position = point3d(startX, spaceY + 2);
    const fontSize = 22;
    const fontColor = 40;
    const alignment = {horizontal: TextHorizontalAlignment.Left, vertical: TextVerticalAlignment.Middle};
    addLabel(drawing, `SECTION ${label}`, fontSize, fontColor, position, alignment);
}

export function addFreeLabel(container, text, fontSize, fontColor, position, alignment = {}) {
    addLabel(
        container,
        text,
        fontSize,
        fontColor,
        position,
        {
            horizontal: alignment.horizontal ?? TextHorizontalAlignment.Center,
            vertical: alignment.vertical ?? TextVerticalAlignment.Middle,
        }
    );
}

// Generic helper function to add a text label to any DXF container (drawing or block)
function addLabel(container, text, fontSize, fontColor, position, alignment) {
    container.addText(position, fontSize, text, {
        rotation: 0,
        horizontalAlignment: alignment.horizontal,
        verticalAlignment: alignment.vertical,
        colorNumber: fontColor,
        secondAlignmentPoint: position, // Used for aligning text properly
    });
}
